<nz-table [nzData]="[1,2]" [nzShowPagination]="false" [nzScroll]="{ x: '1700px' }" class="table-valign-top">
  <thead>
  <tr>
    <th></th>
    <th style="width: 230px">Coverage</th>
    <th>Sum Insured</th>
    <th>Premium rate</th>
    <th>Premium</th>
    <th>Deductible Amount</th>
    <th>Deductible Claim Percentage</th>
    <th style="width: 200px">Remarks</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let r of rows; let i=index;">
    <td data-dd="Actions">
      <div *ngIf="i==0">
        <button nz-button nzType="dashed" (click)="addRow()">
          <i nz-icon nzType="plus"  nzTheme="outline"></i>
        </button>
      </div>
      <div *ngIf="i>0">
        <button nz-button nzType="dashed" nz-popconfirm
        nzPopconfirmTitle="Remove row?" nzOkText="Remove" nzCancelText="Cancel" (nzOnConfirm)="removeRow()">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </div>
    </td>
    <td data-dd="Coverage">
      <nz-select nzShowSearch  style="width:100%;display: block" [ngModel]="i+1">
        <nz-option *ngFor="let i of coverages" [nzLabel]="i.name" [nzValue]="i.id"></nz-option>
      </nz-select>
    </td>
    <td data-dd="Sum Insured">
      <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input [(ngModel)]="sumInsured" [disabled]="true"/></nz-input-group>
    </td>
    <td data-dd="Premium rate">
      <input type="text" nz-input />
    </td>
    <td data-dd="Premium">
      <input type="text" nz-input />
    </td>
    <td data-dd="Deductible Amount">
      <input type="text" nz-input />
    </td>
    <td data-dd="Deductible Claim Percentage">
      <input type="text" nz-input />
    </td>
    <td data-dd="Remarks">
      <textarea nz-input cols="2" rows="2" placeholder="Remarks ..."></textarea>
    </td>
  </tr>
  </tbody>
</nz-table>
